import {GameData} from '../../../server/data/GameData';
import {Presentation} from "../../../../core/gameflow/controller/Presentation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {PunkRocker} from "../../../PunkRocker";
import {PREngineManager} from '../../../punkEngine/PREngineManager';
import {StateHandler} from "../../../../core/utils/StateHandler";
import {SoundManager} from "../../../sound/SoundManager";
import {SoundConfig} from "../../../sound/SoundConfig";
import {InitData} from '../../../server/data/InitData';
import {PRGameMode} from "../../../server/PRGameMode";
import {TrainState} from "../../independent/trains/TrainState";
import {jumpingWildConfig} from "../../../server/base/IData";
import {JumpWildState} from "../../independent/jumpingWild/JumpingWildController";
import {SpinePlayer} from "../../../../core/displayobject/SpinePlayer";

class RespinStates extends StateHandler {
    public static readonly START: string = "start";
    public static readonly EXPLODE: string = "explode";
    public static readonly SHOW: string = "show";
    public static readonly SIGN: string = "sign";
    public static readonly HIDE: string = "hide";
    public static readonly STOP: string = "stop";
    public static readonly DONE: string = "done";
}

export class ModeTriggerPresentation extends Presentation {
    protected playIntroRestore: boolean = false;
    protected totalScattersCount: number = 0;
    private nextMode: string = "";
    //private modeReset: boolean = false;
    private scatterPos: number[] = [];
    private wildPos: number[] = [];
    private xWildPos: number[] = [];
    private _gameData: GameData;
    private respinState: RespinStates = new RespinStates(RespinStates.START);
    private _isRestoreState: boolean = false;
    private _isUpgrade: boolean = false;

    constructor() {
        super();
    }

    public checkForActivation(data: GameData): boolean {
        if (data.raw.nextMode === PRGameMode.RESPIN) {
            return true;
        } else {
            return data.gameModeChanges;
        }
    }

    public setGamedData(data: GameData): void {
        this._gameData = data;
        this.nextMode = data.nextMode;
        this._isRestoreState = data.isRestoreState;
        this.totalScattersCount = data.Reel.amountOfScatters;

        this._isUpgrade = (data.mode === PRGameMode.FREESPIN_LEVEL_ONE
                && (data.nextMode === PRGameMode.FREESPIN_LEVEL_TWO || data.nextMode === PRGameMode.FREESPIN_LEVEL_THREE))
            || (data.mode === PRGameMode.FREESPIN_LEVEL_TWO && data.nextMode === PRGameMode.FREESPIN_LEVEL_THREE);

        this.respinState.set(RespinStates.START);
        this.scatterPos = data.Reel.scatterPositions;
        this.wildPos = data.Reel.wildSinglePos;
        this.xWildPos = data.Reel.xWildPos;
    }

    public createPresentation(enableSkip: Function) {
        // enableSkip(false);

        switch (this.nextMode) {
            case GameMode.RESPIN:
                this.RespinTriggered();
                break;
            case PRGameMode.FREESPIN_LEVEL_ONE:
            case PRGameMode.FREESPIN_LEVEL_TWO:
            case PRGameMode.FREESPIN_LEVEL_THREE:
                enableSkip(false); // #35
                
                this.FreeSpinTrigger();
                break;
            case GameMode.NORMAL:
                this.unlockReels();
                this.PresentationState.setInactive();
                break;
            default:
                this.PresentationState.setInactive();
                break;
        }
    }

    public skip(): void {
    }

    private FreeSpinTrigger(): void {
        if (this.respinState.equal(RespinStates.START)) {
            SoundManager.playSoundEffect(SoundConfig.SCATTER_WIN);
            if (this._isRestoreState) {
                PunkRocker.keypadPlugin.setZeroBetSpinCounter(-1);
            }
            PunkRocker.splashController.setData(this._gameData);
            if (!(this._isUpgrade)) {
                let durr: number = 1;

                PunkRocker.reelEngineManager.AllReels.forEach((r, rid) => {
                    r.AllWindowSymbols.forEach(s => {
                        if (s.isScatter) {
                            if (this._isRestoreState) {
                                if (!(this.totalScattersCount === 5 && r.reelID === 5)) {
                                    this.timeline.add(() => {
                                        s.playScatterLoop(this.totalScattersCount === 5 ? 4 : this.totalScattersCount);
                                    }, 0);
                                }
                            }

                            /*this.timeline.add(() => {
                                s.playScatterHit();
                            }, rid * 0.05);*/
                        }
                    });
                });
                this.timeline.to(this, {duration: durr - 0.35});
            }
            this.respinState.set(RespinStates.EXPLODE)
        } else if (this.respinState.equal(RespinStates.EXPLODE)) {
            SoundManager.playSoundEffect(`fsIntroStartLvl${(this.nextMode === PRGameMode.FREESPIN_LEVEL_ONE ? "1" : (this.nextMode === PRGameMode.FREESPIN_LEVEL_TWO ? "2" : "3"))}`);

            // #354, #376
            PunkRocker.background.setBgAnim("mainGameToBonusGame").eventCallback("onComplete", () => {
                PunkRocker.background.setBgAnim((this.nextMode === PRGameMode.FREESPIN_LEVEL_THREE ? "bonusGameStatic2" : "bonusGameStatic"), true);
            });
            PunkRocker.background.setFrameAnim("mainGameToBonusGame").eventCallback("onComplete", () => {
                PunkRocker.background.setFrameAnim("bonusGameStatic");
            });

            // #365
            if (this.nextMode === PRGameMode.FREESPIN_LEVEL_THREE) {
                PunkRocker.foreground.playForegroundAnimation("burning_train");
            }

            if (!(this._isUpgrade)) {
                PunkRocker.noService.toggleServiceBoard(this.nextMode === PRGameMode.FREESPIN_LEVEL_ONE, this.nextMode);

                this.timeline.to(this, {duration: 0.167});
            }
            this.respinState.set(RespinStates.SHOW);
        } else if (this.respinState.equal(RespinStates.SHOW)) {
            if (!(this._isUpgrade)) {
                PunkRocker.trainsManager.topTrain.toggleDisplay(true);
                PunkRocker.trainsManager.bottomTrain.toggleDisplay((this.nextMode === PRGameMode.FREESPIN_LEVEL_TWO || this.nextMode === PRGameMode.FREESPIN_LEVEL_THREE));
            }
            this.respinState.set(RespinStates.SIGN)
        } else if (this.respinState.equal(RespinStates.SIGN)) {
            if (!(this._isUpgrade)) {
                this.trainArrives();
            }
            this.respinState.set(RespinStates.HIDE);
        } else if (this.respinState.equal(RespinStates.HIDE)) {
            if (this._isUpgrade) {
                const reelWithUpgrade: number[] = [],
                    topTrainFeatures: string[] = this._gameData.raw.topTrain,
                    bottomTrainFeatures: string[] = this._gameData.raw.bottomTrain;

                for (let reelId: number = 0; reelId < PREngineManager.AllReels.length; reelId++) {
                    if (topTrainFeatures[reelId] === "UPGRADE" || bottomTrainFeatures[reelId] === "UPGRADE") {
                        reelWithUpgrade.push(reelId);
                    }
                }
                for (let i: number = 0; i < this._gameData.raw.jumpingWildList.length; i++) {
                    const currJWObj: jumpingWildConfig = this._gameData.raw.jumpingWildList[i];

                    if (reelWithUpgrade.includes(currJWObj.newCoord.x)) {
                        this.timeline.add(PunkRocker.jumpWilds.PlayState(i, JumpWildState.FEATURE_UPGRADE_TRIGGER), 0);
                    }
                }
            }
            this.timeline.add(PunkRocker.posterManager.stop(0));
            this.timeline.add(PunkRocker.splashController.showFSIntro());
            this.respinState.set(RespinStates.STOP);
        } else {
            this.PresentationState.setInactive();
        }
    }

    private RespinTriggered(): void {
        if (this.respinState.equal(RespinStates.START)) {
            this.timeline.to(this, {
                duration: (this._gameData.raw.totalSpinWinnings > 0) ? 1 : 0.001
            });
            this.respinState.set(RespinStates.EXPLODE);
        } else if (this.respinState.equal(RespinStates.EXPLODE)) {
            let lockOffsetTime: number = 0;
            PREngineManager.AllReels.forEach(currReel => {
                const reelId: number = currReel.reelID;

                if (currReel.isActive) {
                    currReel.AllWindowSymbols.forEach(currSym => {
                        if (currSym.isScatter && (this._gameData.mode === PRGameMode.NORMAL)) {
                            this.timeline.add(currSym.turnScatterToRiot(), lockOffsetTime);
                        }
                    });

                    if (this.scatterPos[reelId] >= 0 || this.wildPos[reelId] >= 0 || this.xWildPos[reelId] >= 0) {
                        this.timeline.to(this, {
                            duration: 0.667
                        }, lockOffsetTime);
                        this.timeline.add(() => {
                            currReel.lock(true);
                            SoundManager.crossFadeToMain2(500);
                            if (!(SoundManager.isSoundPlaying(SoundConfig.CHAIN1))) {
                                SoundManager.playSoundEffect(SoundConfig.CHAIN1);
                            }
                        }, lockOffsetTime);
                        lockOffsetTime += 0.1;
                    }
                }
            });
            this.respinState.set(RespinStates.SHOW);
        } else if (this.respinState.equal(RespinStates.SHOW)) {
            this.respinState.set(RespinStates.SIGN);
        } else if (this.respinState.equal(RespinStates.SIGN)) {
            this.respinState.set(RespinStates.HIDE);
        } else {
            this.PresentationState.setInactive();
        }
    }

    private unlockReels(): void {
        if (this._gameData.raw.mode === PRGameMode.RESPIN) {
            PREngineManager.AllReels.forEach(r => {
                if (!(r.isActive)) {
                    r.lock(false);

                    if (!(SoundManager.isSoundPlaying(SoundConfig.CHAIN2))) {
                        SoundManager.playSoundEffect(SoundConfig.CHAIN2);
                    }

                    PunkRocker.waysCounter.stopRiotLoop();
                }
            });
        }
    }

    private trainArrives(): void {
        const nextMode: PRGameMode = this._gameData.raw.nextMode,
            isFS_1: boolean = nextMode === PRGameMode.FREESPIN_LEVEL_ONE,
            isFS_2: boolean = nextMode === PRGameMode.FREESPIN_LEVEL_TWO;

        let topTrainItems: string[],
            bottomTrainItems: string[],
            topTrainDurr: number = 0,
            bottomTrainDurr: number = 0;

        if (isFS_1) {
            topTrainItems = ["PLUS_1", "XWAYS_FS", "UPGRADE", "6X6", "ENABLE_TRAIN", "MOLOTOV_FS"];
            bottomTrainItems = ["X2", "PLUS_1", "X5", "X10", "BJW", "X100"];
        } else if (isFS_2) {
            topTrainItems = ["PLUS_1", "XWAYS_FS", "UPGRADE", "6X6", "X50", "MOLOTOV_FS"];
            bottomTrainItems = ["X2", "PLUS_1", "X5", "X10", "BJW", "X100"];
        } else {
            topTrainItems = ["PLUS_1", "XWAYS_FS", "X10", "6X6", "X50", "MOLOTOV_FS"];
            bottomTrainItems = ["X10", "PLUS_1", "X15", "X25", "BJW", "X100"];
        }

        PunkRocker.trainsManager.topTrain.setTrainItems(topTrainItems);
        PunkRocker.trainsManager.topTrain.setTrainAlpha(true, 0.2);

        if (!isFS_1) {
            PunkRocker.trainsManager.bottomTrain.setTrainItems(bottomTrainItems);
            PunkRocker.trainsManager.bottomTrain.setTrainAlpha(true, 0.2);
        }

        this.timeline.add(() => {
            PunkRocker.jumpWilds.ChangeToSpine();
            PunkRocker.trainsManager.topTrain.setTrainState(TrainState.TRAIN_ENTER);
            if (!isFS_1) {
                PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_ENTER);
            }
            SoundManager.playSoundEffect(SoundConfig.TRAIN_BRAKE);
        }, 0);

        topTrainDurr += SpinePlayer.fetchDuration("topTrainSpine", TrainState.TRAIN_ENTER);

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.setTrainState(TrainState.TRAIN_OPEN_ONLY);
        }, topTrainDurr);

        bottomTrainDurr += SpinePlayer.fetchDuration("bottomTrainSpine", TrainState.TRAIN_ENTER);

        this.timeline.add(() => {
            if (!isFS_1) {
                PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_OPEN_ONLY);
            }
        }, bottomTrainDurr);

        const topTrainShowItemsDelay: number = ((topTrainDurr + PunkRocker.trainsManager.topTrain.getAnimDurr(TrainState.TRAIN_OPEN_ONLY)) - 0.15);

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.showTrainItems(true, [0, 1, 2, 3, 4, 5], 0.3);
        }, topTrainShowItemsDelay);

        if (!isFS_1) {
            const bottomTrainShowItemsDelay: number = ((bottomTrainDurr + PunkRocker.trainsManager.bottomTrain.getAnimDurr(TrainState.TRAIN_OPEN_ONLY)) - 0.15);

            this.timeline.add(() => {
                PunkRocker.trainsManager.bottomTrain.showTrainItems(true, [0, 1, 2, 3, 4, 5], 0.3);
            }, bottomTrainShowItemsDelay);

        }

        this.timeline.add(() => {
            PunkRocker.waysCounter.counterActive(false);
        });
    }
}


export class ModeRestoreTriggerPresentation extends ModeTriggerPresentation {
    public checkForActivation(data: GameData): boolean {
        return data.isRestoreState && !data.raw.numberOfFreespinsPlayed;
    }

    public setInitData(data: InitData): void {

        this.playIntroRestore = data.isRestoreState && !data.raw.numberOfFreespinsPlayed;

        if (this.playIntroRestore) {
            this.totalScattersCount = data.Reel.amountOfScatters;
        }

        this.setGamedData(data);
    }

    preStart(): void {
        if (this.playIntroRestore) {
            this.playIntroRestore = false;
        }
    }
}